import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Penampil jawaban Asisten (markdown). HTML mentah TIDAK dirender (bawaan react-markdown) — jawaban
 * model diperlakukan sebagai teks tak tepercaya. Semua tautan dibuka di jendela baru; di mode Desktop
 * Electron meneruskannya ke browser luar (setWindowOpenHandler → shell.openExternal).
 */
export function IsiJawaban({ isi }: { isi: string }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
        ),
      }}
    >
      {isi}
    </ReactMarkdown>
  );
}
